import axios from 'axios'
import { refreshAccessToken, handleSessionExpiration } from '../utils/token'

export const refreshTokenInterceptor = () => {
  return async (error) => {
    const originalRequest = error.config

    if (shouldRetry(error, originalRequest)) {
      originalRequest._retry = true

      try {
        console.debug('API request failed with auth error, attempting token refresh')
        await refreshAccessToken()
        console.debug('Token refresh successful, retrying original request')
        return axios(originalRequest)
      } catch (refreshError) {
        console.warn('Token refresh failed during API error recovery:', refreshError)
        // Session is expired - trigger immediate logout redirect
        handleSessionExpiration()
        return Promise.reject(refreshError)
      }
    }

    // Handle other auth errors that shouldn't trigger refresh
    if (error.response?.status === 401 || error.response?.status === 403) {
      console.warn('Authentication error that cannot be recovered:', error.response?.status)
      // Session is expired or invalid - trigger immediate logout redirect
      handleSessionExpiration()
      return Promise.reject(error)
    }

    return Promise.reject(error)
  }
}

const RETRY_STATUS_CODES = new Set([401, 403])

export const shouldRetry = (error, originalRequest) => {
  if (originalRequest._retry) {
    return false
  }

  // Network errors might be transient, allow retry
  if (error.code === 'ERR_NETWORK') {
    return true
  }
  
  // Auth errors should trigger token refresh
  if (RETRY_STATUS_CODES.has(error.response?.status)) {
    return true
  }

  return false
}
